import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const discountProductsQueryKey: QueryKey = ['discount-products'];

export const GET_DISCOUNT_PRODUCTS = 'api/v2/discount/select-discount-products';

export type DiscountProduct = {
  Available: number;
  AvailableUnitAbbreviation: string;
  Brand: string | null;
  BrandId: number | null;
  Category: string | null;
  CategoryId: number | null;
  ChargeCodeId: number | null;
  Cultivator: string | null;
  InventoryTagIds: number[] | null;
  InvId: number;
  IsRetired: boolean;
  MasterCategory: string | null;
  ProductDesc: string;
  ProductId: number;
  ProductNo: string;
  Strain: string | null;
  StrainId: number | null;
  TagIds: number[] | null;
  UnitTypeName: string;
  Vendor: string | null;
  VendorId: number | null;
  Weight: number;
};

type DiscountProductsPayload = {
  SelectedLspId?: number;
};

export function useDiscountProductsQuery(payload?: DiscountProductsPayload) {
  const { SelectedLspId = undefined } = payload ?? {};
  return useQuery({
    queryKey: SelectedLspId ? [...discountProductsQueryKey, SelectedLspId] : discountProductsQueryKey,
    queryFn: () =>
      postData<{ DisplayType: string }, DiscountProduct[]>({
        endpoint: GET_DISCOUNT_PRODUCTS,
        ...(SelectedLspId ? { LspId: SelectedLspId } : {}),
        payload: { DisplayType: '' },
      }),
  });
}
